import flow from 'lodash/flow'
import isFunction from 'lodash/isFunction'
import isNil from 'lodash/isNil'

import { convertToStringWithSeparator } from 'Shared/utils/number'

import { TO_FIXED_TWO_DECIMALS } from 'Core/constants'

export const roundFloat = (number: number): string => number.toFixed(TO_FIXED_TWO_DECIMALS)

const isNumberPosivite = (number: number): boolean => number > 0

const convertToNegative = (value: string): string => `-${value}`

export const withDollarSign = (dollar: string): string => `$${dollar}`

const digitsAfterDecimal = (value: string): number => (value.split('.')[1] || []).length

const addCurrencyTail = (value: string) => {
	const digitsAfterDot = digitsAfterDecimal(value)

	if (digitsAfterDot === 0) {
		return `${value}.00`
	}

	if (digitsAfterDot === 1) {
		return `${value}0`
	}

	return value
}

export const displayCurrency = (
	input: number | null | undefined,
	withCurrencySign = true
): string => {
	if (isNil(input) || isNaN(input)) {
		return ''
	}

	if (input === 0) {
		return withCurrencySign ? withDollarSign('0.00') : '0.00'
	}

	const isPosivite = isNumberPosivite(input)
	const isInteger = Number.isInteger(input)

	const refinedInput = Math.abs(input)
	const pipeline: (input: number) => string = flow(
		[
			...(isInteger ? [] : [roundFloat]),
			convertToStringWithSeparator,
			addCurrencyTail,
			...(withCurrencySign ? [withDollarSign] : []),
			...(isPosivite ? [] : [convertToNegative])
		].filter(isFunction)
	)

	return pipeline(refinedInput)
}

export const withCurrencyCode = (value: Key, currencyCode?: string) => {
	if (!currencyCode) {
		return `${value}`
	}

	return `${value} ${currencyCode}`
}
